function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import RootSiblings from 'react-native-root-siblings';
import ToastContainer, { positions, durations } from './ToastContainer';
class Toast extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_toast", null);
    _defineProperty(this, "componentDidMount", () => {
      this._toast = new RootSiblings(/*#__PURE__*/React.createElement(ToastContainer, _extends({}, this.props, {
        duration: 0
      })));
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      this._toast.update(/*#__PURE__*/React.createElement(ToastContainer, _extends({}, this.props, {
        duration: 0
      })));
    });
    _defineProperty(this, "componentWillUnmount", () => {
      this._toast.destroy();
    });
  }
  render() {
    return null;
  }
}
_defineProperty(Toast, "displayName", 'Toast');
_defineProperty(Toast, "propTypes", ToastContainer.propTypes);
_defineProperty(Toast, "positions", positions);
_defineProperty(Toast, "durations", durations);
_defineProperty(Toast, "show", (message, options = {
  position: positions.BOTTOM,
  duration: durations.SHORT
}) => {
  let instance = {
    destroy: () => {}
  };
  const onHidden = () => {
    options.onHidden && options.onHidden();
    instance.destroy();
  };
  instance = new RootSiblings(/*#__PURE__*/React.createElement(ToastContainer, _extends({}, options, {
    onHidden: onHidden,
    visible: true
  }), message));
  return instance;
});
_defineProperty(Toast, "hide", toast => {
  if (toast instanceof RootSiblings) {
    toast.destroy();
  } else {
    console.warn(`Toast.hide expected a \`RootSiblings\` instance as argument.\nBut got \`${typeof toast}\` instead.`);
  }
});
export { RootSiblings as Manager };
export default Toast;